
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";

function SidebarList({ children }) {
  return (
    <List
      sx={{
        px: 2,
        my: 0.3,
      }}
    >
      {children}
    </List>
  );
}

// Typechecking props for the SidebarList
SidebarList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SidebarList;
